import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'centimeterToMeter'
})
export class CentimeterToMeterPipe implements PipeTransform {
    transform(value: number | null | undefined): string {
        if (value == null || isNaN(value)) { return ''; }
        return (value / 100).toFixed(2);
    }
}
